import { Redirect, Route, Switch } from 'react-router-dom';
import AccessControl from '../../AccessControl';
import {
  CONFIG_TOY_TABS,
  PERMISSIONS_KEY,
  ROUTES,
  TAGS_CONFIG_SUBTYPES,
} from '../../common/constants';
import ConfigTags from './modules/tags/pages/ConfigTags';
import ConfigToy from './modules/toy/pages/ConfigToy';
import Configs from './pages/Configs';

const ConfigsWrapper = () => (
  <Switch>
    <Route
      exact
      path={ROUTES?.CONFIGS}
      render={() => (
        <Redirect to={`${ROUTES?.CONFIGS}${ROUTES?.SYSTEM_CONFIGS}`} />
      )}
    />
    <Route
      exact
      path={`${ROUTES?.CONFIGS}${ROUTES?.SYSTEM_CONFIGS}`}
      render={(props) => (
        <AccessControl permissionKey={PERMISSIONS_KEY?.CONFIGS}>
          <Configs {...props} />
        </AccessControl>
      )}
    />
    <Route
      exact
      path={`${ROUTES?.CONFIGS}${ROUTES?.DYNAMIC_CONFIGS}`}
      render={() => (
        <Redirect
          to={`${ROUTES?.CONFIGS}${ROUTES?.DYNAMIC_CONFIGS}${ROUTES?.CONFIG_TAGS_USERS}`}
        />
      )}
    />
    <Route
      exact
      path={`${ROUTES?.CONFIGS}${ROUTES?.DYNAMIC_CONFIGS}/tags`}
      render={() => (
        <Redirect
          to={`${ROUTES?.CONFIGS}${ROUTES?.DYNAMIC_CONFIGS}${ROUTES?.CONFIG_TAGS_USERS}`}
        />
      )}
    />
    <Route
      exact
      path={`${ROUTES?.CONFIGS}${ROUTES?.TAGS}`}
      render={() => (
        <Redirect
          to={`${ROUTES?.CONFIGS}${ROUTES?.DYNAMIC_CONFIGS}${ROUTES?.CONFIG_TAGS_USERS}`}
        />
      )}
    />
    <Route
      exact
      path={`${ROUTES?.CONFIGS}${ROUTES?.DYNAMIC_CONFIGS}${ROUTES?.CONFIG_TAGS_USERS}`}
      render={(props) => (
        <AccessControl permissionKey={PERMISSIONS_KEY?.MASTER_LIST_TAG}>
          <ConfigTags
            {...props}
            initialTab={TAGS_CONFIG_SUBTYPES?.USERS?.value}
          />
        </AccessControl>
      )}
    />
    <Route
      exact
      path={`${ROUTES?.CONFIGS}${ROUTES?.DYNAMIC_CONFIGS}${ROUTES?.CONFIG_TAGS_ORDERS}`}
      render={(props) => (
        <AccessControl permissionKey={PERMISSIONS_KEY?.MASTER_LIST_TAG}>
          <ConfigTags
            {...props}
            initialTab={TAGS_CONFIG_SUBTYPES?.ORDERS?.value}
          />
        </AccessControl>
      )}
    />
    <Route
      exact
      path={`${ROUTES?.CONFIGS}${ROUTES?.DYNAMIC_CONFIGS}${ROUTES?.CONFIG_TAGS_REVIEW}`}
      render={(props) => (
        <AccessControl permissionKey={PERMISSIONS_KEY?.MASTER_LIST_TAG}>
          <ConfigTags
            {...props}
            initialTab={TAGS_CONFIG_SUBTYPES?.REVIEW?.value}
          />
        </AccessControl>
      )}
    />
    <Route
      exact
      path={`${ROUTES?.CONFIGS}${ROUTES?.DYNAMIC_CONFIGS}${ROUTES?.CONFIG_TAGS_INVENTORY}`}
      render={(props) => (
        <AccessControl permissionKey={PERMISSIONS_KEY?.MASTER_LIST_TAG}>
          <ConfigTags
            {...props}
            initialTab={TAGS_CONFIG_SUBTYPES?.INVENTORY?.value}
          />
        </AccessControl>
      )}
    />
    <Route
      exact
      path={`${ROUTES?.CONFIGS}${ROUTES?.DYNAMIC_CONFIGS}${ROUTES?.CONFIG_TOY_AVAILABILITY}`}
      render={(props) => (
        <AccessControl permissionKey={PERMISSIONS_KEY?.CONFIGS}>
          <ConfigToy
            {...props}
            initialTab={CONFIG_TOY_TABS?.AVAILABILITY?.key}
          />
        </AccessControl>
      )}
    />
    <Route
      exact
      path={`${ROUTES?.CONFIGS}${ROUTES?.DYNAMIC_CONFIGS}${ROUTES?.CONFIG_TOY_RANKING}`}
      render={(props) => (
        <AccessControl permissionKey={PERMISSIONS_KEY?.CONFIGS}>
          <ConfigToy {...props} initialTab={CONFIG_TOY_TABS?.RANKING?.key} />
        </AccessControl>
      )}
    />
    <Route
      exact
      path={`${ROUTES?.CONFIGS}${ROUTES?.DYNAMIC_CONFIGS}${ROUTES?.CONFIG_TOY_RESERVATION_RULES}`}
      render={(props) => (
        <AccessControl permissionKey={PERMISSIONS_KEY?.CONFIGS}>
          <ConfigToy
            {...props}
            initialTab={CONFIG_TOY_TABS?.RESERVATION_RULES?.key}
          />
        </AccessControl>
      )}
    />
  </Switch>
);

export default ConfigsWrapper;
